export default {
  sourceGeo: (state) => state.sourceGeo,
  isLoading: (state) => state.isLoading,
  hasError: (state) => !!state.error,
  error: (state) => state.error,
};
